import { Component } from '@angular/core';
import { BaseImports } from '../shared/imports/base-imports';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css'],
  standalone: true,
  imports: [...BaseImports]
})
export class LandingPageComponent { }
